var SwitchImg = {
  // btn01用のオブジェクト

  init:function () {
    this.switch();
  },

  switch: function() {
    var $setElem = $('.switch'),
        pcName = '_pc',
        spName = '_sp';
        replaceWidth = 769;

    $setElem.each(function(){
      var $this = $(this);
      function imgSize(){
        var winWidth = window.innerWidth;
        if(winWidth != 'undefind'){
          if(winWidth <= replaceWidth){
            $this.attr('src', $this.attr('src').replace(pcName,spName));
          } else {
            $this.attr('src', $this.attr('src').replace(spName,pcName));
          }
        }
      }
      $(window).on('resize', function(){
        imgSize();
      });
      imgSize();
    });
  }

};



module.exports = SwitchImg;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_switchImg.js
// module id = 9
// module chunks = 0